/* eslint import/imports-first: 0 */
import React, { Component } from 'react';
import { syncHistoryWithStore } from 'react-router-redux';
import { Provider } from 'react-redux';
import { Router, browserHistory } from 'react-router';
import Store from '../store/Store';
import Authentication from '../Authentication';
import routes from '../config/Routes';
import { persistStore } from 'redux-persist';
import IsLoading from './ui/IsLoading';
const history = syncHistoryWithStore(browserHistory, Store);

/**
 * INFO:
 * This class loads the saved state from localStorage
 * and then loads the Application.
 * In ../config/Routes.js the main App is wrapped in requireAuthentication(App)
 * which then looks for the key oauth.isAuthenticated in the store.
 * If oauth.isAuthenticated === false -> redirect to '/login'
 * else redirect to '/'
 */
class AppProvider extends Component {
    constructor() {
        super();
        this.state = { rehydrated: false, wait: true };
    }

    componentWillMount() {
        persistStore(
            Store,
            {
                blacklist: ['authReducer'],
                whitelist: []
            },
            () => {
                this.setState({ rehydrated: true });
            }
        );

        process.env.NODE_ENV === 'DEV'
            ? this.setState({ wait: false })
            : setTimeout(() => {
                  this.setState({ wait: false });
              }, 2000);
    }

    render() {
        if (!this.state.rehydrated || this.state.wait) {
            return <IsLoading />;
        }
        // If you're signed in and paste a valid url
        // you'll get moved to your location
        //
        // TODO:
        //
        // const savedRoute = Store.getState().routing.locationBeforeTransitions.pathname;
        // if (window.location.pathname !== savedRoute) {
        //   browserHistory.push(window.location.pathname);
        // }
        return (
            <Provider store={Store}>
                <Router history={history} routes={routes(Authentication)} />
            </Provider>
        );
    }
}

export default AppProvider;



// WEBPACK FOOTER //
// ./src/components/AppProvider.js